import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  GET_USER_REGISTRATIONS,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

/********************************
 * @DESC ROLE MANAGEMENT SUPER ADMIN
 *******************************/

// export const Referral_cashback_add =
//   (token, formData,onSuccessAddOffer) => async (dispatch) => {
//     console.log(token, formData);
//     try {
//       dispatch({ type: CLEAR_ERRORS });
//       let response = await axios.post(
//         `${serverApi}/referralprogram`,
//         formData,
//       {
//         headers: {
//           Authorization: token,
//           "Content-Type": "application/json",
//         },
//       }
//       );
//       if (response.status === 201) {
//         Alert.success(`<h4> Updated succesfully</h4>`, {
//           position: "top-right",
//           effect: "bouncyflip",
//           beep: true,
//           html: true,
//           timeout: 5000,
//           offset: 35,
//         });
//         onSuccessAddOffer();
//       }
//     }catch (err) {
//       Alert.error(`<h4>${err.response.data.message}</h4>`, {
//         position: "top-right",
//         effect: "bouncyflip",
//         beep: true,
//         html: true,
//         timeout: 3000,
//         offset: 35,
//       });
//       dispatch({ type: CLEAR_LOADER });
//       dispatch(setErrors(err));
//     }
//     // onErrorAddOffer();
//   };

export const userRegistrations_Amealio_get = (token,dateQuery) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADER });
    dispatch({ type: CLEAR_ERRORS });
    let response = await axios.get(`${serverApi}/non-user-sms?startDate=${dateQuery.startDate}&endDate=${dateQuery.endDate}`, {
      headers: {
        Authorization: token,
      },
    });
    if (response.status === 200) {
      dispatch({ type:   GET_USER_REGISTRATIONS, payload: response.data });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    Alert.error(
      `<h4>${err?.response?.data || "Please enter correct details."}</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      }
    );
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

